const AIRPORT_LOUNGE_INDEX: Record<string, Array<string>> =
  {
    '44': [
      'cln:HNL',
    ],
    '102': [
      'cln:MXL',
    ],
    '104': [
      'cln:ONT',
    ],
    '116': [
      'cln:SMF',
    ],
    '120': [
      'cln:TIJ',
    ],
    '145': [
      'cln:SAN',
    ],
    '146': [
      'cln:PDX',
    ],
    '147': [
      'cln:OAK',
    ],
    '149': [
      'cln:SFO',
    ],
    '150': [
      'cln:LAS',
    ],
    '152': [
      'cln:YVR',
    ],
    '166': [
      'cln:CJS',
    ],
    '168': [
      'cln:COS',
    ],
    '169': [
      'cln:CUU',
    ],
    '176': [
      'cln:CUL',
    ],
    '196': [
      'cln:HMO',
    ],
    '202': [
      'cln:LAP',
    ],
    '208': [
      'cln:MZT',
    ],
    '224': [
      'cln:SJD',
    ],
    '234': [
      'cln:YEG',
    ],
    '253': [
      'cln:PHX',
    ],
    '255': [
      'cln:YYC',
    ],
    '259': [
      'cln:ACA',
    ],
    '263': [
      'cln:AGU',
    ],
    '275': [
      'cln:BJX',
    ],
    '299': [
      'cln:DGO',
    ],
    '306': [
      'cln:SJO',
    ],
    '314': [
      'cln:GDL',
    ],
    '336': [
      'cln:HUX',
    ],
    '344': [
      'cln:IAH',
    ],
    '369': [
      'cln:MCI',
    ],
    '377': [
      'cln:MID',
    ],
    '386': [
      'cln:MTT',
    ],
    '387': [
      'cln:MTY',
    ],
    '393': [
      'cln:OAX',
    ],
    '405': [
      'cln:PVR',
    ],
    '407': [
      'cln:QRO',
    ],
    '409': [
      'cln:REX',
    ],
    '414': [
      'cln:SAL',
    ],
    '417': [
      'cln:SCY',
    ],
    '421': [
      'cln:SLP',
    ],
    '428': [
      'cln:STL',
    ],
    '430': [
      'cln:TAM',
    ],
    '433': [
      'cln:TGZ',
    ],
    '434': [
      'cln:TAP',
    ],
    '436': [
      'cln:TUL',
    ],
    '442': [
      'cln:VER',
    ],
    '443': [
      'cln:TRC',
    ],
    '445': [
      'cln:VSA',
    ],
    '447': [
      'cln:XNA',
    ],
    '466': [
      'cln:YWG',
    ],
    '473': [
      'cln:ZIH',
    ],
    '476': [
      'cln:MSP',
    ],
    '479': [
      'cln:DFW',
    ],
    '482': [
      'cln:MEX',
    ],
    '483': [
      'cln:ORD',
    ],
    '484': [
      'cln:MLB',
    ],
    '501': [
      'cln:ATA',
    ],
    '503': [
      'cln:AXM',
    ],
    '507': [
      'cln:BAQ',
    ],
    '511': [
      'cln:BDL',
    ],
    '513': [
      'cln:BGA',
    ],
    '534': [
      'cln:CIX',
    ],
    '535': [
      'cln:CJA',
    ],
    '541': [
      'cln:CMH',
    ],
    '547': [
      'cln:CTG',
    ],
    '548': [
      'cln:CUZ',
    ],
    '549': [
      'cln:CVG',
    ],
    '553': [
      'cln:CUC',
    ],
    '558': [
      'cln:DTW',
    ],
    '560': [
      'cln:EJA',
    ],
    '563': [
      'cln:EOH',
      'cln:MDE',
    ],
    '572': [
      'cln:EYP',
    ],
    '584': [
      'cln:GSP',
    ],
    '598': [
      'cln:IQT',
    ],
    '599': [
      'cln:IAD',
    ],
    '616': [
      'cln:LET',
    ],
    '626': [
      'cln:MBJ',
    ],
    '635': [
      'cln:MHH',
    ],
    '640': [
      'cln:MTR',
    ],
    '645': [
      'cln:NAS',
    ],
    '649': [
      'cln:NVA',
    ],
    '651': [
      'cln:OCC',
    ],
    '658': [
      'cln:PCL',
    ],
    '669': [
      'cln:PIU',
    ],
    '673': [
      'cln:PPN',
    ],
    '675': [
      'cln:PSO',
    ],
    '676': [
      'cln:PTY',
    ],
    '687': [
      'cln:PVD',
    ],
    '707': [
      'cln:SYR',
    ],
    '713': [
      'cln:TBP',
    ],
    '718': [
      'cln:TRU',
    ],
    '726': [
      'cln:TPP',
    ],
    '727': [
      'cln:TYL',
    ],
    '729': [
      'cln:VVC',
    ],
    '791': [
      'cln:YUL',
    ],
    '792': [
      'cln:YOW',
    ],
    '793': [
      'cln:PHL',
    ],
    '794': [
      'cln:MCO',
    ],
    '797': [
      'cln:BOG',
    ],
    '801': [
      'cln:MIA',
    ],
    '802': [
      'cln:YYZ',
    ],
    '803': [
      'cln:CUN',
    ],
    '804': [
      'cln:BOS',
    ],
    '807': [
      'cln:LGA',
    ],
    '808': [
      'cln:JFK',
    ],
    '812': [
      'cln:ANU',
    ],
    '821': [
      'cln:AUA',
    ],
    '822': [
      'cln:BDA',
    ],
    '823': [
      'cln:BGI',
    ],
    '834': [
      'cln:CBB',
    ],
    '837': [
      'cln:CCS',
    ],
    '838': [
      'cln:CGB',
    ],
    '839': [
      'cln:CGR',
    ],
    '843': [
      'cln:CJC',
    ],
    '846': [
      'cln:CUR',
    ],
    '848': [
      'cln:DOM',
    ],
    '856': [
      'cln:GEO',
    ],
    '857': [
      'cln:GND',
    ],
    '867': [
      'cln:LRM',
    ],
    '872': [
      'cln:LPB',
    ],
    '873': [
      'cln:MAO',
    ],
    '892': [
      'cln:POP',
    ],
    '897': [
      'cln:PTP',
    ],
    '898': [
      'cln:PUJ',
    ],
    '914': [
      'cln:SJU',
    ],
    '920': [
      'cln:STI',
    ],
    '924': [
      'cln:SXM',
    ],
    '931': [
      'cln:UVF',
    ],
    '937': [
      'cln:VVI',
    ],
    '966': [
      'cln:SCL',
    ],
    '973': [
      'cln:AEP',
    ],
    '976': [
      'cln:AJU',
    ],
    '977': [
      'cln:BEL',
    ],
    '979': [
      'cln:BPS',
    ],
    '980': [
      'cln:BRC',
    ],
    '984': [
      'cln:CGH',
    ],
    '985': [
      'cln:CNF',
    ],
    '987': [
      'cln:COR',
    ],
    '989': [
      'cln:CPV',
    ],
    '990': [
      'cln:CRD',
    ],
    '992': [
      'cln:CWB',
    ],
    '997': [
      'cln:FLN',
    ],
    '999': [
      'cln:FTE',
    ],
    '1003': [
      'cln:GYN',
    ],
    '1004': [
      'cln:IGR',
    ],
    '1005': [
      'cln:IGU',
    ],
    '1007': [
      'cln:IOS',
    ],
    '1011': [
      'cln:JDO',
    ],
    '1015': [
      'cln:JOI',
    ],
    '1016': [
      'cln:JPA',
    ],
    '1020': [
      'cln:JUJ',
    ],
    '1022': [
      'cln:LDB',
    ],
    '1026': [
      'cln:MCZ',
    ],
    '1028': [
      'cln:MDZ',
    ],
    '1029': [
      'cln:MGF',
    ],
    '1030': [
      'cln:MCP',
    ],
    '1036': [
      'cln:NAT',
    ],
    '1038': [
      'cln:NVT',
    ],
    '1046': [
      'cln:PMW',
    ],
    '1049': [
      'cln:RAO',
    ],
    '1050': [
      'cln:REC',
    ],
    '1051': [
      'cln:REL',
    ],
    '1056': [
      'cln:ROS',
    ],
    '1061': [
      'cln:SDU',
    ],
    '1063': [
      'cln:SLZ',
    ],
    '1065': [
      'cln:SJP',
    ],
    '1066': [
      'cln:SLA',
    ],
    '1070': [
      'cln:THE',
    ],
    '1073': [
      'cln:USH',
    ],
    '1076': [
      'cln:UDI',
    ],
    '1077': [
      'cln:VCP',
    ],
    '1080': [
      'cln:VIX',
    ],
    '1081': [
      'cln:XAP',
    ],
    '1084': [
      'cln:EZE',
    ],
    '1085': [
      'cln:GIG',
    ],
    '1086': [
      'cln:GRU',
    ],
    '1104': [
      'cln:ABZ',
    ],
    '1105': [
      'cln:ACC',
    ],
    '1110': [
      'cln:AGA',
    ],
    '1119': [
      'cln:BHD',
    ],
    '1121': [
      'cln:BJL',
    ],
    '1148': [
      'cln:EMA',
    ],
    '1154': [
      'cln:FEZ',
    ],
    '1161': [
      'cln:FAO',
    ],
    '1162': [
      'cln:EXT',
    ],
    '1166': [
      'cln:FUE',
    ],
    '1175': [
      'cln:HUY',
    ],
    '1178': [
      'cln:INV',
    ],
    '1179': [
      'cln:IOM',
    ],
    '1182': [
      'cln:JER',
    ],
    '1197': [
      'cln:LBA',
    ],
    '1202': [
      'cln:LTN',
    ],
    '1207': [
      'cln:LPL',
    ],
    '1213': [
      'cln:MME',
    ],
    '1218': [
      'cln:NDR',
    ],
    '1223': [
      'cln:NOC',
    ],
    '1225': [
      'cln:NQY',
    ],
    '1227': [
      'cln:NWI',
    ],
    '1230': [
      'cln:OPO',
    ],
    '1232': [
      'cln:OUD',
    ],
    '1250': [
      'cln:SEN',
    ],
    '1254': [
      'cln:SNN',
    ],
    '1255': [
      'cln:SOU',
    ],
    '1259': [
      'cln:STN',
    ],
    '1269': [
      'cln:TNG',
    ],
    '1278': [
      'cln:VIL',
    ],
    '1289': [
      'cln:ORK',
    ],
    '1290': [
      'cln:LIS',
    ],
    '1291': [
      'cln:EDI',
      'led:006Ii000002JL6KIAW',
    ],
    '1292': [
      'cln:CMN',
    ],
    '1296': [
      'cln:MAN',
    ],
    '1297': [
      'cln:NCL',
    ],
    '1298': [
      'cln:BFS',
    ],
    '1299': [
      'cln:BHX',
    ],
    '1300': [
      'cln:DUB',
    ],
    '1302': [
      'cln:LGW',
      'led:006Ii000002JL6BIAW',
    ],
    '1303': [
      'led:006RF00000MyGYKYA3',
      'cln:LHR',
    ],
    '1305': [
      'cln:AAL',
    ],
    '1327': [
      'cln:BGY',
    ],
    '1333': [
      'cln:BLL',
    ],
    '1334': [
      'cln:BLQ',
    ],
    '1339': [
      'cln:BRE',
    ],
    '1340': [
      'cln:BRI',
    ],
    '1343': [
      'cln:BSL',
    ],
    '1344': [
      'cln:BTS',
    ],
    '1352': [
      'cln:CAG',
    ],
    '1356': [
      'cln:CGN',
    ],
    '1359': [
      'cln:COO',
    ],
    '1361': [
      'cln:CTA',
    ],
    '1368': [
      'cln:DLA',
    ],
    '1371': [
      'cln:DRS',
    ],
    '1391': [
      'cln:GDN',
    ],
    '1395': [
      'cln:FMO',
    ],
    '1398': [
      'cln:GIB',
    ],
    '1400': [
      'cln:GOT',
    ],
    '1407': [
      'cln:GRZ',
    ],
    '1413': [
      'cln:HAJ',
    ],
    '1425': [
      'cln:INN',
    ],
    '1438': [
      'cln:KSC',
    ],
    '1442': [
      'cln:KTW',
    ],
    '1447': [
      'cln:LBV',
    ],
    '1454': [
      'cln:LEJ',
    ],
    '1460': [
      'cln:LIN',
    ],
    '1461': [
      'cln:LJU',
    ],
    '1465': [
      'cln:LNZ',
    ],
    '1468': [
      'cln:LUX',
    ],
    '1469': [
      'cln:LUZ',
    ],
    '1475': [
      'cln:LPI',
    ],
    '1482': [
      'cln:MIR',
    ],
    '1495': [
      'cln:NBE',
    ],
    '1509': [
      'cln:NUE',
    ],
    '1520': [
      'cln:OSR',
    ],
    '1525': [
      'cln:ORY',
    ],
    '1537': [
      'cln:PMO',
    ],
    '1539': [
      'cln:POZ',
    ],
    '1543': [
      'cln:PSA',
    ],
    '1562': [
      'cln:RTM',
    ],
    '1566': [
      'cln:SCQ',
    ],
    '1580': [
      'cln:SJJ',
    ],
    '1595': [
      'cln:SZG',
    ],
    '1602': [
      'cln:TIA',
    ],
    '1603': [
      'cln:TIV',
    ],
    '1611': [
      'cln:TRN',
    ],
    '1615': [
      'cln:TUN',
    ],
    '1635': [
      'cln:WDH',
    ],
    '1636': [
      'cln:WMI',
    ],
    '1638': [
      'cln:WRO',
    ],
    '1644': [
      'cln:ZAD',
    ],
    '1645': [
      'cln:WAW',
    ],
    '1646': [
      'cln:ZRH',
    ],
    '1647': [
      'cln:ZAG',
    ],
    '1648': [
      'cln:VIE',
    ],
    '1649': [
      'cln:VCE',
    ],
    '1651': [
      'cln:SKP',
    ],
    '1653': [
      'cln:PRG',
    ],
    '1655': [
      'cln:DUS',
    ],
    '1656': [
      'cln:MUC',
    ],
    '1657': [
      'cln:MRS',
    ],
    '1658': [
      'cln:MLA',
    ],
    '1659': [
      'cln:KRK',
    ],
    '1660': [
      'cln:HAM',
    ],
    '1661': [
      'cln:GVA',
    ],
    '1662': [
      'cln:FLR',
    ],
    '1663': [
      'cln:DBV',
    ],
    '1664': [
      'cln:CRL',
    ],
    '1665': [
      'cln:CPH',
    ],
    '1666': [
      'cln:BUD',
    ],
    '1667': [
      'cln:BRU',
    ],
    '1673': [
      'cln:ARN',
    ],
    '1677': [
      'cln:BCN',
    ],
    '1679': [
      'cln:MAD',
    ],
    '1681': [
      'cln:AMS',
    ],
    '1682': [
      'cln:FCO',
    ],
    '1683': [
      'cln:NCE',
    ],
    '1684': [
      'cln:MXP',
    ],
    '1685': [
      'cln:FRA',
    ],
    '1698': [
      'cln:AQJ',
    ],
    '1700': [
      'cln:ASW',
    ],
    '1703': [
      'cln:BBK',
    ],
    '1709': [
      'cln:BFN',
    ],
    '1713': [
      'cln:BOJ',
    ],
    '1714': [
      'cln:BUQ',
    ],
    '1716': [
      'cln:CFU',
    ],
    '1719': [
      'cln:CLJ',
    ],
    '1728': [
      'cln:ELS',
    ],
    '1732': [
      'cln:FBM',
    ],
    '1734': [
      'cln:GBE',
    ],
    '1740': [
      'cln:GRJ',
    ],
    '1743': [
      'cln:HER',
    ],
    '1745': [
      'cln:HBE',
    ],
    '1747': [
      'cln:HLA',
    ],
    '1753': [
      'cln:HRG',
    ],
    '1779': [
      'cln:KGL',
    ],
    '1802': [
      'cln:LUN',
    ],
    '1803': [
      'cln:LVI',
    ],
    '1805': [
      'cln:LXR',
    ],
    '1820': [
      'cln:MPM',
    ],
    '1821': [
      'cln:MQP',
    ],
    '1841': [
      'cln:PLZ',
    ],
    '1851': [
      'cln:RIX',
    ],
    '1853': [
      'cln:RHO',
    ],
    '1861': [
      'cln:SOF',
    ],
    '1869': [
      'cln:SSH',
    ],
    '1880': [
      'cln:TLL',
    ],
    '1891': [
      'cln:VAR',
    ],
    '1893': [
      'cln:VFA',
    ],
    '1895': [
      'cln:VNO',
    ],
    '1904': [
      'cln:TSR',
    ],
    '1907': [
      'cln:LCA',
    ],
    '1909': [
      'cln:HRE',
    ],
    '1910': [
      'cln:HEL',
    ],
    '1911': [
      'cln:BEY',
    ],
    '1912': [
      'cln:AMM',
    ],
    '1913': [
      'cln:CAI',
    ],
    '1914': [
      'cln:JMK',
    ],
    '1915': [
      'cln:SKG',
    ],
    '1916': [
      'cln:CPT',
    ],
    '1917': [
      'cln:ATH',
    ],
    '1918': [
      'cln:DUR',
    ],
    '1919': [
      'cln:JNB',
    ],
    '1922': [
      'cln:ADB',
    ],
    '1924': [
      'cln:AHB',
    ],
    '1942': [
      'cln:AYT',
    ],
    '1947': [
      'cln:BGW',
    ],
    '1950': [
      'cln:BJV',
    ],
    '1958': [
      'cln:DAR',
    ],
    '1961': [
      'cln:DIY',
    ],
    '1962': [
      'cln:DLM',
    ],
    '1963': [
      'cln:DMM',
    ],
    '1967': [
      'cln:DOH',
    ],
    '1971': [
      'cln:EBB',
    ],
    '2008': [
      'cln:JED',
    ],
    '2014': [
      'cln:JRO',
    ],
    '2027': [
      'cln:KWI',
    ],
    '2038': [
      'cln:MBA',
    ],
    '2039': [
      'cln:MED',
    ],
    '2053': [
      'cln:MSQ',
    ],
    '2078': [
      'cln:RUH',
    ],
    '2081': [
      'cln:SAW',
      'led:006RF00000MDf2cYAD',
    ],
    '2093': [
      'cln:TIF',
    ],
    '2098': [
      'cln:TNR',
    ],
    '2099': [
      'cln:TUU',
    ],
    '2130': [
      'cln:ZNZ',
    ],
    '2133': [
      'cln:NBO',
    ],
    '2135': [
      'cln:IST',
    ],
    '2136': [
      'cln:ESB',
    ],
    '2137': [
      'cln:ADD',
    ],
    '2174': [
      'cln:BUS',
    ],
    '2176': [
      'cln:DWC',
    ],
    '2177': [
      'cln:EVN',
    ],
    '2179': [
      'cln:GYD',
    ],
    '2186': [
      'cln:MCT',
    ],
    '2192': [
      'cln:SLL',
    ],
    '2194': [
      'cln:TBS',
    ],
    '2197': [
      'cln:SHJ',
    ],
    '2198': [
      'cln:MRU',
    ],
    '2199': [
      'led:006RF00000GaxzfYAB',
      'cln:DXB',
    ],
    '2200': [
      'cln:AUH',
    ],
    '2218': [
      'cln:GUW',
    ],
    '2222': [
      'cln:ISB',
    ],
    '2227': [
      'cln:KHI',
    ],
    '2233': [
      'cln:MUX',
    ],
    '2243': [
      'cln:PEW',
    ],
    '2250': [
      'cln:SKD',
    ],
    '2256': [
      'cln:TAS',
    ],
    '2262': [
      'cln:URA',
    ],
    '2264': [
      'cln:MLE',
    ],
    '2265': [
      'cln:LHE',
    ],
    '2269': [
      'cln:BBI',
    ],
    '2270': [
      'cln:BDQ',
    ],
    '2272': [
      'cln:BHO',
    ],
    '2273': [
      'cln:CCJ',
    ],
    '2275': [
      'cln:DED',
    ],
    '2276': [
      'cln:DIB',
    ],
    '2278': [
      'cln:GAU',
    ],
    '2279': [
      'cln:GOI',
    ],
    '2280': [
      'cln:GWL',
    ],
    '2282': [
      'cln:IDR',
    ],
    '2283': [
      'cln:IXA',
    ],
    '2285': [
      'cln:IXC',
    ],
    '2286': [
      'cln:IXD',
    ],
    '2288': [
      'cln:IXJ',
    ],
    '2290': [
      'cln:IXM',
    ],
    '2292': [
      'cln:JAI',
    ],
    '2299': [
      'cln:LKO',
    ],
    '2301': [
      'cln:NAG',
    ],
    '2303': [
      'cln:PNQ',
    ],
    '2308': [
      'cln:SXR',
    ],
    '2310': [
      'cln:TRV',
    ],
    '2311': [
      'cln:TRZ',
    ],
    '2313': [
      'cln:VTZ',
    ],
    '2316': [
      'cln:HYD',
    ],
    '2317': [
      'cln:DEL',
    ],
    '2318': [
      'cln:COK',
    ],
    '2319': [
      'cln:CMB',
    ],
    '2320': [
      'cln:CCU',
    ],
    '2321': [
      'cln:BOM',
    ],
    '2322': [
      'cln:BLR',
    ],
    '2323': [
      'cln:ATQ',
    ],
    '2324': [
      'cln:AMD',
    ],
    '2352': [
      'cln:KTM',
    ],
    '2356': [
      'cln:CIT',
    ],
    '2359': [
      'cln:BSZ',
    ],
    '2360': [
      'cln:KGF',
    ],
    '2371': [
      'cln:DAC',
    ],
    '2375': [
      'cln:MDL',
    ],
    '2378': [
      'cln:RGN',
    ],
    '2381': [
      'cln:BTH',
    ],
    '2383': [
      'cln:DJB',
    ],
    '2389': [
      'cln:PKU',
    ],
    '2391': [
      'cln:PLM',
    ],
    '2392': [
      'cln:PNK',
    ],
    '2394': [
      'cln:SOC',
    ],
    '2395': [
      'cln:SRG',
    ],
    '2399': [
      'cln:SUB',
    ],
    '2400': [
      'cln:KNO',
    ],
    '2401': [
      'cln:CGK',
    ],
    '2406': [
      'cln:BMV',
    ],
    '2408': [
      'cln:CEI',
    ],
    '2410': [
      'cln:CXR',
    ],
    '2411': [
      'cln:DIN',
    ],
    '2413': [
      'cln:DMK',
      'led:006RF00000O6tjxYAB',
    ],
    '2415': [
      'cln:HDY',
    ],
    '2416': [
      'cln:HPH',
    ],
    '2417': [
      'cln:HUI',
    ],
    '2430': [
      'cln:PQC',
    ],
    '2431': [
      'cln:PXU',
    ],
    '2436': [
      'cln:TBB',
    ],
    '2438': [
      'cln:UIH',
    ],
    '2442': [
      'led:006Ii000002JKZBIA4',
      'cln:UTH',
    ],
    '2444': [
      'cln:VCA',
    ],
    '2446': [
      'cln:VCL',
    ],
    '2447': [
      'cln:VCS',
    ],
    '2448': [
      'cln:VDH',
    ],
    '2449': [
      'cln:VII',
    ],
    '2456': [
      'cln:SAI',
    ],
    '2457': [
      'cln:KTI',
    ],
    '2459': [
      'cln:DAD',
    ],
    '2460': [
      'cln:KBV',
    ],
    '2461': [
      'cln:CNX',
      'led:006Ii000002JKX2IAO',
    ],
    '2462': [
      'cln:USM',
    ],
    '2464': [
      'led:006RF00000O6qKgYAJ',
      'cln:BKK',
    ],
    '2465': [
      'led:006RF00000GdWRqYAN',
      'cln:HAN',
    ],
    '2466': [
      'led:006RF00000OOPFZYA5',
      'led:006Ii000002JFZlIAO',
      'cln:HKT',
    ],
    '2467': [
      'led:006RF00000GdXcPYAV',
      'cln:SGN',
    ],
    '2497': [
      'cln:BAV',
    ],
    '2498': [
      'cln:BDJ',
    ],
    '2507': [
      'cln:CGO',
    ],
    '2508': [
      'cln:CGQ',
    ],
    '2511': [
      'cln:CKG',
    ],
    '2513': [
      'cln:CSX',
    ],
    '2514': [
      'cln:CZX',
    ],
    '2515': [
      'cln:DAT',
    ],
    '2519': [
      'cln:DLC',
    ],
    '2520': [
      'cln:DLU',
    ],
    '2521': [
      'cln:DNH',
    ],
    '2524': [
      'cln:DYG',
    ],
    '2531': [
      'cln:HAK',
    ],
    '2532': [
      'cln:HET',
    ],
    '2533': [
      'cln:HFE',
    ],
    '2534': [
      'cln:HGH',
    ],
    '2536': [
      'cln:HJJ',
    ],
    '2537': [
      'cln:HLD',
    ],
    '2540': [
      'cln:HRB',
    ],
    '2545': [
      'cln:JGN',
    ],
    '2546': [
      'cln:JGS',
    ],
    '2547': [
      'cln:JHB',
    ],
    '2548': [
      'cln:JHG',
    ],
    '2549': [
      'cln:JJN',
    ],
    '2556': [
      'cln:KHN',
    ],
    '2557': [
      'cln:KMG',
    ],
    '2558': [
      'cln:KOE',
    ],
    '2564': [
      'cln:KWE',
    ],
    '2565': [
      'cln:KWL',
    ],
    '2570': [
      'cln:LHW',
    ],
    '2571': [
      'cln:LJG',
    ],
    '2574': [
      'cln:LUM',
    ],
    '2578': [
      'cln:LYG',
    ],
    '2580': [
      'cln:LOP',
    ],
    '2582': [
      'cln:MDC',
    ],
    '2584': [
      'cln:MIG',
    ],
    '2593': [
      'cln:NGB',
    ],
    '2594': [
      'cln:NKG',
    ],
    '2595': [
      'cln:NNG',
    ],
    '2596': [
      'cln:NNY',
    ],
    '2604': [
      'cln:SHA',
    ],
    '2606': [
      'cln:SJW',
    ],
    '2607': [
      'cln:SWA',
    ],
    '2609': [
      'cln:SYX',
    ],
    '2610': [
      'cln:SZB',
    ],
    '2611': [
      'cln:SZX',
    ],
    '2612': [
      'cln:TCZ',
    ],
    '2615': [
      'cln:TNA',
    ],
    '2617': [
      'cln:TRK',
    ],
    '2618': [
      'cln:TSN',
    ],
    '2620': [
      'cln:UPG',
    ],
    '2621': [
      'cln:URC',
    ],
    '2622': [
      'cln:UYN',
    ],
    '2623': [
      'cln:TXN',
    ],
    '2624': [
      'cln:TYN',
    ],
    '2625': [
      'cln:WEH',
    ],
    '2626': [
      'cln:WNZ',
    ],
    '2628': [
      'cln:XUZ',
    ],
    '2629': [
      'cln:YBP',
    ],
    '2630': [
      'cln:YCU',
    ],
    '2631': [
      'cln:WUS',
    ],
    '2632': [
      'cln:WUX',
    ],
    '2633': [
      'cln:XFN',
    ],
    '2635': [
      'cln:XIY',
    ],
    '2636': [
      'cln:YIH',
    ],
    '2638': [
      'cln:YIW',
    ],
    '2640': [
      'cln:YNT',
    ],
    '2641': [
      'cln:YNZ',
    ],
    '2642': [
      'cln:YTY',
    ],
    '2646': [
      'cln:ZUH',
    ],
    '2647': [
      'cln:XMN',
    ],
    '2648': [
      'cln:WUH',
    ],
    '2649': [
      'cln:TAO',
    ],
    '2650': [
      'led:006Ii000002JJv2IAG',
      'cln:SIN',
    ],
    '2651': [
      'cln:SHE',
    ],
    '2652': [
      'cln:KCH',
    ],
    '2653': [
      'cln:FOC',
    ],
    '2655': [
      'cln:BPN',
    ],
    '2656': [
      'cln:BKI',
    ],
    '2657': [
      'cln:CAN',
    ],
    '2658': [
      'cln:DPS',
    ],
    '2659': [
      'led:006RF00000MDf2QYAT',
      'led:006RF00000MDf2RYAT',
      'cln:KUL',
    ],
    '2660': [
      'cln:LGK',
      'led:006RF00000MDf2SYAT',
    ],
    '2661': [
      'cln:PVG',
    ],
    '2662': [
      'cln:PEN',
      'led:006RF00000MDf2TYAT',
      'led:006RF00000MDf2UYAT',
    ],
    '2663': [
      'cln:PEK',
    ],
    '2671': [
      'cln:BWN',
    ],
    '2677': [
      'cln:CRK',
    ],
    '2711': [
      'cln:PPS',
    ],
    '2724': [
      'cln:TSA',
    ],
    '2735': [
      'cln:TPE',
    ],
    '2737': [
      'cln:MFM',
    ],
    '2741': [
      'cln:HKG',
    ],
    '2744': [
      'cln:DVO',
    ],
    '2745': [
      'cln:CEB',
    ],
    '2746': [
      'asp:164',
      'cln:PER',
    ],
    '2747': [
      'cln:MNL',
    ],
    '2766': [
      'cln:AMQ',
    ],
    '2784': [
      'cln:GMP',
      'led:006RF00000MDf2OYAT',
    ],
    '2790': [
      'cln:HND',
    ],
    '2849': [
      'cln:PUS',
      'led:006RF00000MDf2PYAT',
    ],
    '2850': [
      'cln:NGO',
      'led:006RF00000CEyGjYAL',
    ],
    '2852': [
      'cln:FUK',
    ],
    '2854': [
      'led:006RF00000MDf2LYAT',
      'cln:ICN',
      'led:006RF00000MDf2MYAT',
      'led:006RF00000MDf2NYAT',
    ],
    '2855': [
      'cln:KIX',
    ],
    '2856': [
      'cln:NRT',
    ],
    '2885': [
      'led:006Ii000002JJwxIAG',
      'cln:ADL',
    ],
    '2997': [
      'cln:CNS',
    ],
    '3005': [
      'led:006Ii000002JJwsIAG',
      'cln:BNE',
    ],
    '3008': [
      'asp:208',
      'cln:SYD',
    ],
    '3073': [
      'cln:VLI',
    ],
    '3129': [
      'cln:ZQN',
    ],
    '3130': [
      'cln:CHC',
    ],
    '3131': [
      'cln:AKL',
    ],
    '3134': [
      'cln:NAN',
    ],
    '3309': [
      'cln:INC',
    ],
    '3402': [
      'asp:207',
      'cln:MEL',
    ],
    '3405': [
      'cln:CNN',
    ],
    '3409': [
      'cln:RPR',
    ],
    '3417': [
      'cln:VNS',
    ],
    '3421': [
      'cln:BER',
    ],
    '3424': [
      'cln:LDY',
    ],
    '3428': [
      'cln:IXR',
    ],
    '3436': [
      'cln:NAP',
    ],
    '3455': [
      'cln:GOX',
    ],
    '3460': [
      'cln:HYN',
    ],
    '3462': [
      'cln:YIA',
    ],
    '3470': [
      'cln:NLU',
    ],
    '3475': [
      'cln:PBC',
    ],
    '3476': [
      'cln:PFO',
    ],
    '3477': [
      'cln:CZM',
    ],
    '3833': [
      'cln:PKX',
    ],
    '3866': [
      'cln:TQO',
    ],
  }
export default AIRPORT_LOUNGE_INDEX
